import React, { useEffect, useState } from 'react';
import { Button, Popover, Radio } from 'antd';
import { apiHolder, apis, conf } from 'api';
import classNames from 'classnames';
import styles from './detail.module.scss';
import ContactTrackerIns from '../../tracker';
import { getIn18Text } from 'api';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const SendMailPop = ({ children, mailList, onSend, testId, _account }) => {
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState(mailList && mailList[0] ? mailList[0] : '');
    useEffect(() => {
        setValue(mailList && mailList[0] ? mailList[0] : '');
    }, [mailList]);
    const handleSend = () => {
        if (apiHolder.env.forElectron) {
            mailApi.doWriteMailToContact([value], _account);
        }
        else if (systemApi.isMainPage()) {
            mailApi.doWriteMailToContact([value], _account);
        }
        else {
            const host = conf('host');
            const params = new URLSearchParams({
                writeMailToContact: value,
                _account: _account || '',
            });
            systemApi.openNewWindow(`${host}/#?${params}`, false);
        }
        onSend && onSend();
        setVisible(false);
        ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAYOUJIAN'));
    };
    if (!mailList || mailList.length === 1) {
        if (React.isValidElement(children)) {
            return React.cloneElement(children, Object.assign(Object.assign({}, children.props), { onClick: handleSend }));
        }
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Popover, { getPopupContainer: nd => nd.parentElement || document.body, content: React.createElement("div", { className: styles.sendMailContent },
            React.createElement("p", null, getIn18Text('CILIANXIRENYOU')),
            React.createElement(Radio.Group, { className: styles.radioWrapper, value: value, onChange: e => setValue(e.target.value) }, mailList.map(email => (React.createElement(Radio, { value: email, key: email }, email)))),
            React.createElement("div", { className: classNames(styles.buttonWrapper, {
                    [styles.buttonWrapperBordered]: mailList.length > 3,
                }) },
                React.createElement(Button, { onClick: () => setVisible(false), style: { marginRight: 12 } }, getIn18Text('QUXIAO')),
                React.createElement(Button, { type: "primary", "data-test-id": testId, onClick: handleSend }, getIn18Text('QUEDING')))), onVisibleChange: setVisible, visible: visible, trigger: "click", placement: "bottom" }, children));
};
export default SendMailPop;
